import * as React from 'react';

import SwitchViewContext from './SwitchViewContext';
import SwitchViewDefaultFragment from './SwitchViewDefaultFragment';
import SwitchViewFragment from './SwitchViewFragment';

export default class SwitchView extends React.Component {
  static displayName = 'SwitchView';
  static Fragment = SwitchViewFragment;
  static DefaultFragment = SwitchViewDefaultFragment;

  static getDerivedStateFromProps(props, state) {
    if (props.activeId && props.initialViewId) {
      throw new Error(
        `<LegacySwitchView activeId="${props.activeId}" initialViewId="${props.initialViewId}"/> - should not be used together`
      );
    }

    const useExternalSignals = props.hasOwnProperty('initialViewId');

    return {
      useExternalSignals,
      activeViewId: useExternalSignals
        ? state.activeViewId || props.initialViewId
        : props.activeId,
    };
  }

  state = {
    activeViewId: null,
    viewIds: [],
  };

  handleAddView = (viewId) => {
    this.setState((state) => ({
      viewIds: [...state.viewIds, viewId],
    }));

    return () => {
      const index = this.state.viewIds.indexOf(viewId);

      if (index === -1) {
        return;
      }

      const viewIds = [...this.state.viewIds];
      viewIds.splice(index, 1);

      this.setState({ viewIds });
    };
  };

  activateView = (viewId) => {
    this.setState({ activeViewId: viewId });

    if (this.props.onSwitch) {
      this.props.onSwitch(viewId);
    }
  };

  render() {
    const { children } = this.props;

    return (
      <SwitchViewContext.Provider
        value={{
          activateView: this.activateView,
          activeViewId: this.state.activeViewId,
          shouldShowDefault:
            this.state.viewIds.indexOf(this.state.activeViewId) === -1,
          addView: this.handleAddView,
        }}
      >
        {children}
      </SwitchViewContext.Provider>
    );
  }
}
